import http from "../../http-common";

const getOrganizations = async () => {
  return await http
    .get("/admin/organizations")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getOrganizationById = async (id) => {
  return await http
    .get(`/admin/organizations/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const updateOrganization = async (id, data) => {
  return await http
    .put(`/admin/organizations/${id}`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadOrganizationCoverPhoto = async (id, formData) => {
  return await http
    .post(`/admin/organizations/${id}/cover`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getBankAccount = async (id) => {
  return await http
    .get(`/admin/organizations/${id}/bank-account`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const createBankAccount = async (id, data) => {
  return await http
    .post(`/admin/organizations/${id}/bank-account`, data)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const inactiveBankAccount = async (organizationId, bankAccountId) => {
  return await http
    .delete(`/admin/organizations/${organizationId}/bank-account/${bankAccountId}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

export default {
  getOrganizations,
  getOrganizationById,
  updateOrganization,
  uploadOrganizationCoverPhoto,
  getBankAccount,
  createBankAccount,
  inactiveBankAccount,
};
